import {http} from '../http'
import * as featureSettingsApi from '../../coreApi/feature-settings'

import {APIResponse} from '../types'
import {Client} from '../../../types'
import {handleError} from '../handleError'

interface Params {
  id: number
  clientID: Client['ID']
  // PersonID stored on the PersonTargetFeature row (its original granter).
  // The server matches it in SQL on DELETE, so the request must echo back
  // the row's own granter PersonID — capture it from listPersonTargetFeatures
  // rather than substituting the calling admin's PersonID. See
  // coreApi/feature-settings/deletePersonTargetFeature.ts for the full auth
  // model. Already a number on the listPersonTargetFeatures row, so no cast
  // needed.
  granterPersonID: number
}

type DeletePersonTargetFeatureReturn = APIResponse<undefined>

export interface DeletePersonTargetFeature {
  (params: Params): Promise<DeletePersonTargetFeatureReturn>
}

const ERROR_PATH = 'api.featuresettings.deletePersonTargetFeature()'
const GENERIC_ERROR =
  'Something went wrong while revoking feature access. Please try again.'

export const deletePersonTargetFeature: DeletePersonTargetFeature = async ({
  id,
  clientID,
  granterPersonID,
}) => {
  try {
    await featureSettingsApi.deletePersonTargetFeature(http, {
      ID: id,
      ClientID: Number(clientID),
      PersonID: granterPersonID,
    })

    return {
      result: 'success',
      data: undefined,
    }
  } catch (e) {
    return handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
}
